import React, {FC} from "react"

import {useBusinessRedemptionReport} from "@irati/adminReporting/hooks"
import Loading from "@irati/ui/src/Loading"
import {RedemptionReportDuration} from "@irati/types"
import auth from "@irati/auth"
import {H4} from "@irati/ui/src/Typography"
import {Card} from "@irati/ui/src/Layout"

import SavingsTable from "./SavingsTable"

interface Props {
  duration: RedemptionReportDuration
  month: {
    month: number
    year: number
  }
}

const BusinessTopRedemptions: FC<Props> = ({duration, month}) => {
  const variables = {
    businessId: auth.business().uuid,
    duration,
    month: duration === RedemptionReportDuration.Monthly ? month : undefined,
    limit: 10
  }
  const {data, load} = useBusinessRedemptionReport(variables)
  return (
    <Loading load={load}>
      <H4 marginBottom={2}>Popular in {auth.business().businessName}</H4>
      <Card padding={[0, 1]}>
        <SavingsTable data={data?.report?.perks} showRedemptionCount showRanking />
      </Card>
    </Loading>
  )
}

export default BusinessTopRedemptions
